import { Stack, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProgressContainer } from "./ProgressContainer";
import { useLearnerProgressQuery } from "../../queries";
import { TitleTypography } from "../../styles/CommonWidgetStyles/Typography";
import { CommonWidgetContainer } from "../Commons/CommonWidgetContainer.styles";
import { WidgetSkeleton } from "../WidgetSkeleton/WidgetSkeleton.component";

export const UserProgressWidget = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { t } = useTranslation();
  const { data: userProgress, isFetching, isLoadingError } = useLearnerProgressQuery({ enabled });
  if (!userProgress) {
    return null;
  }

  const hasMandatoryCourses = userProgress?.mandatory &&
    (userProgress.mandatory.los > 0 || userProgress.mandatory.completedLos > 0);

  if ((userProgress?.attributes.length === 0) && !hasMandatoryCourses) {
    return null;
  }

  return (
    <CommonWidgetContainer hasSidePadding={ false }>
      <WidgetContainerStyle>
        <TitleTypography>{ t("your_progress") }</TitleTypography>
        { isLoadingError && (
          <Typography sx={ { paddingY:"2rem", paddingLeft:"1rem" } } fontSize="0.85rem">{ t("error_message") }</Typography>
        ) }
        { isFetching ? <WidgetSkeleton /> : (
          <ProgressContainer
            userProgress={ userProgress }
          />
        ) }
      </WidgetContainerStyle>
    </CommonWidgetContainer>
  );

};

export const WidgetContainerStyle = styled(Stack)(() => ({
  // width:"24rem"
}));
